import React from 'react'
import { Edit, useForm } from '@refinedev/antd'
import { Form, Input, InputNumber, Switch, Descriptions } from 'antd'
import type { Tables } from '@muaa/shared'

type Campaign = Tables<'campaigns'>

export function CampaignEdit() {
  const { formProps, saveButtonProps, query } = useForm<Campaign>()
  const record = query?.data?.data

  return (
    <Edit saveButtonProps={saveButtonProps}>
      {/* Read-only computed fields */}
      <Descriptions style={{ marginBottom: 24 }} column={2} bordered size="small">
        <Descriptions.Item label="Raised">
          {record != null
            ? `$${Number(record.raised).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`
            : '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Donors">
          {record != null ? String(record.donors) : '—'}
        </Descriptions.Item>
      </Descriptions>

      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: 'Campaign title is required' }]}
        >
          <Input placeholder="e.g. Annual Fund 2025" />
        </Form.Item>

        <Form.Item
          label="Goal ($)"
          name="goal"
          rules={[{ required: true, message: 'Goal is required' }]}
        >
          <InputNumber
            min={0}
            precision={2}
            style={{ width: '100%' }}
            formatter={(value) =>
              value != null ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            }
            parser={(value) => (value ? value.replace(/\$\s?|(,*)/g, '') : '') as any}
          />
        </Form.Item>

        <Form.Item label="Days Remaining" name="days_remaining">
          <InputNumber min={0} style={{ width: '100%' }} precision={0} />
        </Form.Item>

        <Form.Item label="Active" name="is_active" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  )
}
